export const comments_3899729 = {"data":{"data":[],"links":{}}}